import { compose } from "redux";
import React, { useState } from "react";
import Close from "@material-ui/icons/Close";
import amber from "@material-ui/core/colors/amber";
import { withStyles } from "@material-ui/core/styles";
import { SnackbarContent, IconButton } from "@material-ui/core";

const EmployeeHiddenWarning = ({ employee, classes }) => {
  const [displayWarning, closeWarning] = useState(true);

  if (employee.get("hideInPlanning") && displayWarning) {
    return (
      <SnackbarContent
        action={
          <IconButton onClick={() => closeWarning(false)}>
            <Close fontSize="small" />
          </IconButton>
        }
        message="This employee card is hidden from the Personnel Planner view"
        classes={{
          root: classes.snackbarContentRoot,
        }}
      />
    );
  }

  return null;
};

const styles = theme => ({
  snackbarContentRoot: {
    fontWeight: 500,
    maxWidth: "none",
    boxShadow: theme.shadows[1],
    backgroundColor: amber[300],
    color: theme.palette.text.primary,
  },
});

export default compose(withStyles(styles))(EmployeeHiddenWarning);
